import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <blockquote>
      <p parentName="blockquote">{`It's quite hard to debug any deployment issue on the cPanel or any managed server as the provider manages this type of server, and they've complete control of the server.  And for that, We don't recommend Cpanel or any managed server for API deployment or frontend deployment. We suggest you use any VPS server where you have complete control of it. you can purchase any $5 – $10/mo server from amazon lightsail, ec2 or digitalocean or any ubuntu server`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`If you still decide to proceed with panel based server, our support team won't be able to help you. We have put some resources for Cpanel in this documentation section to help our users to get started but other than that, we don't have much to offer with Cpanel or any Managed Server`}</p>
    </blockquote>
    <h1 {...{
      "id": "vercel"
    }}>{`Vercel`}</h1>
    <h3 {...{
      "id": "vercelcom"
    }}><a parentName="h3" {...{
        "href": "https://vercel.com/"
      }}>{`vercel.com`}</a></h3>
    <p>{`If you want to host the template in vercel.com then follow the below command`}</p>
    <h3 {...{
      "id": "api"
    }}>{`API`}</h3>
    <p>{`It's not possible to host the API to vercel. Vercel doesn't support laravel API deployment. So you've to host the API on a separate server. We suggest you create a VPS server and host the API there. For more details, follow this `}<a parentName="p" {...{
        "href": "/vps-server"
      }}>{`VPS Deployment`}</a>{` docs.`}</p>
    <p>{`After the host, you'll get your API URL.`}</p>
    <h3 {...{
      "id": "frontend"
    }}>{`Frontend`}</h3>
    <p>{`Now for frontend add API URL and other necessary con
fig details to,`}</p>
    <pre><code parentName="pre" {...{}}>{`shop -> vercel.json
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`admin -> rest -> vercel.json
`}</code></pre>
    <p>{`after that, install vercel-cli on your computer using this command,`}</p>
    <pre><code parentName="pre" {...{}}>{`npm i -g vercel-cli
`}</code></pre>
    <p>{`After that, log in to vercel using this command,`}</p>
    <pre><code parentName="pre" {...{}}>{`vercel login
`}</code></pre>
    <p>{`Then go to the `}<inlineCode parentName="p">{`shop`}</inlineCode>{` directory and use this command to deploy,`}</p>
    <pre><code parentName="pre" {...{}}>{`vercel
`}</code></pre>
    <p>{`Similarly, go to the `}<inlineCode parentName="p">{`admin -> rest`}</inlineCode>{` directory and use this command to deploy,`}</p>
    <pre><code parentName="pre" {...{}}>{`vercel
`}</code></pre>
    <p>{`For more details,`}</p>
    <p>{`Please follow `}<a parentName="p" {...{
        "href": "https://nextjs.org/docs/deployment"
      }}>{`nextjs deployment docs: `}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      